module.exports = __webpack_public_path__ + "img/top-3-5.e7d105bb.jpg";